// webapp/frontend/src/plugins/primevue.js
import PrimeVue from 'primevue/config'
import TreeTable from 'primevue/treetable/treetable.esm.js'
import Column from 'primevue/column/column.esm.js'

// PrimeVue styles (minimal)
import 'primevue/resources/themes/lara-light-blue/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'

export default {
  install(app) {
    app.use(PrimeVue, { ripple: true })
    app.component('TreeTable', TreeTable)
    app.component('PColumn', Column)
  }
}


